import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import logoImg from 'src/images/logo.svg'
import { getJpTitle, getPagesName, PAGE_IDS } from "src/utils/exportFunctions"

const Header = ({ siteTitle }) => (
    <header className="
        fixed top-0 left-0 w-full h-24 bg-white bg-opacity-80 z-20
    ">
        <div className="
            flex justify-between items-center w-full h-full max-w-screen-xl mx-auto
            xl:max-w-1000px
        ">
            <h1 className="
                relative ml-5 z-20
                md:ml-14
                xl:ml-0
            ">
                <Link to='/'><img src={logoImg} alt="ライオン企画株式会社" /></Link>
            </h1>
            <div>
                <ul className="
                    hidden
                    xl:flex xl:text-14px xl:font-normal xl:tracking-49em
                ">
                    <li className="xl:px-6 xl:leading-18px xl:border-r xl:border-base">
                        <Link to={'/' + getPagesName(PAGE_IDS['services'])} className="xl:pl-49em">{getJpTitle(PAGE_IDS['services'])}</Link>
                    </li>
                    <li className="xl:px-6 xl:leading-18px xl:border-r xl:border-base">
                        <Link to={'/' + getPagesName(PAGE_IDS['company'])} className="xl:pl-49em">{getJpTitle(PAGE_IDS['company'])}</Link>
                    </li>
                    <li className="xl:pl-6 xl:leading-18px">
                        <Link to={'/' + getPagesName(PAGE_IDS['access'])} className="xl:pl-49em">{getJpTitle(PAGE_IDS['access'])}</Link>
                    </li>
                </ul>
            </div>
        </div>
    </header>
)

Header.propTypes = {
    siteTitle: PropTypes.string,
}

Header.defaultProps = {
    siteTitle: ``,
}

export default Header
